import ApiService from "../../../common/api.service";

export async function GetBranchs({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("BRANCH_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/branch/page", option);
    commit("BRANCH_SUCCESS", _response);
  } catch (error) {
    commit("BRANCH_ERROR", { result: error.message });
  }
}
